<template>
    <d-modal
        v-cloak
        name="itInn"
        size="wide"
        :no-scroll="true"
        popup-title="Проверка участия IT-компании"
    >
        <p class="p1">Пожалуйста, укажите ИНН или наименование организации, в которой вы работаете, чтобы узнать соответствует ли она требованиям программы </p>
        <div class="inn-wrapper">
            <div class="noUi noui_pb">
				<vue-suggestion
					name="inn"
					id="inn"
					v-model="inn"
					label="ИНН"
					method="party"
					@select="suggestionOptions.onSelect($event)"
				>
				</vue-suggestion>
            </div>
        </div>
        <button class="inn-submit" @click.prevent="checkOkved">Проверить</button>
        <div class="inn-success _mt-16" v-if="innChecker === 'success'">
            <div class="inn-special-wrapper">
                <div class="inn-special-icon__yes"></div>
                <div class="inn-special-text">Организация соответствует требованиям программы</div>
            </div>
        </div>
        <div class="inn-failure _mt-16" v-if="innChecker === 'failure'">
            <div class="inn-special-wrapper">
                <div class="inn-special-icon__no"></div>
                <div class="inn-special-text">Для сотрудников вашей организации условия программы недоступны</div>
            </div>
        </div>
    </d-modal>
</template>

<script>
import axios from 'axios';

export default {
	name: "ItMortgageInn",
	data() {
		return {
			inn: '',
			innNumber: '',
			innRouteMortgage: '/rest/v1/accreditedItCompany/',
			innChecker: '',
			suggestionOptions: {
				onSelect: (suggestion) => {
					this.innNumber = suggestion.data.inn;
				}
			}
		}
	},
	methods: {
		checkOkved() {
			axios.get(`${this.innRouteMortgage}${this.innNumber}?sessid=${window.config.bitrix_sessid}`, {headers: {'Accept': 'application/vnd.api+json'}})
				.then((response) => {
					this.innChecker = response.data.data.attributes.inn === this.innNumber ? 'success' : 'failure';
				}
			)
			.catch(() => {
				this.innChecker = 'failure';
			})
		}
	}
}
</script>
